import { extends as _extends } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';
import { Done } from 'emotion-icons/material';
import Brandy from '../Brandy/index.js';
import Typography from '../Typography/index.js';
import Price from '../Price/index.js';
import List from '../List/index.js';
import ListItem from '../List/ListItem.js';

var PackageProvider = function PackageProvider(_ref) {
  var _ref$bullets = _ref.bullets,
    bullets = _ref$bullets === void 0 ? [] : _ref$bullets,
    _ref$details = _ref.details,
    details = _ref$details === void 0 ? [] : _ref$details,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? '' : _ref$name,
    _ref$termsLink = _ref.termsLink,
    termsLink = _ref$termsLink === void 0 ? '' : _ref$termsLink,
    price = _ref.price;
  return /*#__PURE__*/React.createElement(React.Fragment, null, name && /*#__PURE__*/React.createElement(Typography, {
    className: "leshen-package-provider title",
    variant: "h5"
  }, name), details && /*#__PURE__*/React.createElement("div", {
    className: "details"
  }, details.map(function (detail) {
    return /*#__PURE__*/React.createElement("span", {
      key: detail
    }, detail);
  })), price && price.amount && /*#__PURE__*/React.createElement(Price, _extends({
    className: "price"
  }, price), price.disclaimer && /*#__PURE__*/React.createElement(Brandy, {
    symbol: price.disclaimer.symbol,
    text: price.disclaimer.text,
    variant: "legal"
  })), bullets.length > 0 && /*#__PURE__*/React.createElement(List, {
    className: "list"
  }, bullets.map(function (bullet) {
    return /*#__PURE__*/React.createElement(ListItem, {
      className: "list-item",
      key: bullet.text,
      icon: /*#__PURE__*/React.createElement(Done, null)
    }, /*#__PURE__*/React.createElement(Typography, null, bullet.text), bullet.disclaimer && /*#__PURE__*/React.createElement(Brandy, {
      className: "bullet-disclaimer",
      variant: "legal",
      text: bullet.disclaimer.text,
      symbol: price.disclaimer.symbol
    }));
  })), termsLink && /*#__PURE__*/React.createElement("a", {
    href: "/terms",
    className: "terms"
  }, termsLink));
};
var PackageProvider$1 = PackageProvider;

export { PackageProvider$1 as default };
//# sourceMappingURL=index.js.map
